import React from "react";
import Cal from "@calcom/embed-react";
import "./CalModal.css";

const CalModal = ({isOpen, hideCalModal}) => {


    return (
        <div>
            {isOpen && (
            <div className={"calendar-container"}>
                <div className={"header"}>
                    <button onClick={hideCalModal} className={"close"}>✕</button>
                </div>
                <div className={"calendar"}>
                    <Cal calLink="louisnguyen" className={"calendar-plugin"}></Cal>
                </div>
            </div>)

            }
        </div>


    );
};

export default CalModal;
